import PropTypes from 'prop-types';

export const StocksDefaultProps = {
  stocks: [],
};
export const StocksPropTypes = {
  stocks: PropTypes.arrayOf(
    PropTypes.shape({
      company: PropTypes.string,
      warehouse: PropTypes.string,
      warehouse_code: PropTypes.string,
      quantity: PropTypes.number,
      delay: PropTypes.number,
    }),
  ),
};
